import { shipmentApiClient } from '../shipmentApiClient'
import { addShipmentVisitEndpoint } from './endpoint'
import type {
  AddShipmentVisitParams,
  AddShipmentVisitRequest,
  AddShipmentVisitResponse,
} from './type'

export const addShipmentVisit = async (
  params: AddShipmentVisitParams
): Promise<AddShipmentVisitResponse> => {
  const body: AddShipmentVisitRequest = {
    delivery_report_uid: params.deliveryReportUid,
    driver_phone: params.driverPhone,
  }
  const res = await shipmentApiClient.post<AddShipmentVisitResponse>(
    addShipmentVisitEndpoint(params.shipmentUid),
    body
  )
  return res.data
}
